export const APP_YEAR = 2024